// extracted by mini-css-extract-plugin
export default {"mdBreak":"1024px","line":"EA8bFiWDIt_oBDw3DYbB","phoneNumberLine":"fs8dVlqdT2O7_eJT2P0Y","saveButton":"O6tVw_ug9NvBTpJVup6g","countryFlag":"FzDYJyplOEngCYwBYNcH"};